<div class="card gradient-row primary two-factor-notice" *ngIf="show" data-testid="two-factor-notice">
  <i class="fa fa-shield" aria-hidden="true"></i>
  <span>
    A verificação em duas etapas da sua conta não está ativa.
    Ative para proteger o acesso com um segundo fator além da senha.
  </span>

  <div class="acoes">
    <a class="acao ativar" [routerLink]="['/profile']" data-testid="two-factor-notice-link">Ativar agora</a>

    <button
      type="button"
      class="acao dispensar"
      [ngbPopover]="confirmacao"
      popoverTitle="Não exibir mais?"
      triggers="manual"
      placement="bottom auto"
      container="body"
      popoverClass="two-factor-notice-popover"
      #popover="ngbPopover"
      [disabled]="dismissing"
      (click)="popover.open()"
      data-testid="two-factor-notice-dismiss">
      Não exibir mais
    </button>
  </div>

  <ng-template #confirmacao>
    <p class="mb-2">
      O aviso não volta a aparecer nesta conta. A verificação em duas etapas continua
      disponível em <b>Meus Dados</b> quando você quiser ativar.
    </p>
    <div class="d-flex justify-content-end" style="gap: 8px;">
      <button type="button" class="btn btn-sm btn-link text-muted p-0 px-2"
              (click)="popover.close()" data-testid="two-factor-notice-dismiss-cancel">
        Cancelar
      </button>
      <button type="button" class="btn btn-sm btn-danger"
              (click)="dismiss(popover)" data-testid="two-factor-notice-dismiss-confirm">
        Sim, não exibir mais
      </button>
    </div>
  </ng-template>
</div>
